module.exports = __webpack_public_path__ + "img/carousel-1.625b6b85.png";